"use strict";

var _classCallCheck = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParticlesInteractorBase = void 0;

var Enums_1 = require("../Enums");

var ParticlesInteractorBase = function ParticlesInteractorBase(container) {
  _classCallCheck(this, ParticlesInteractorBase);

  this.container = container;
  this.type = Enums_1.InteractorType.Particles;
};

exports.ParticlesInteractorBase = ParticlesInteractorBase;